<!-- Template for the action button that parent component can render -->
<ng-template #actionButton>
  <iris-button
    id="pendo-ebcg-payment-info-submission"
    data-test="button-add-payment-method"
    [type]="IrisButtonTypes.PRIMARY"
    [typeAttribute]="IrisButtonTypeAttributeOptions.BUTTON"
    [iconPosition]="IrisButtonIconPositions.RIGHT"
    [disabled]="!allowSubmit"
    (click)="openPaymentProvider()"
  >
    Add payment method
    <iris-icon
      [name]="'external_link'" 
      [size]="IrisIconSizes.SM" 
      [color]="allowSubmit ? IconColors.WHITE : IconColors.BLACK">
    </iris-icon>
  </iris-button>
</ng-template>

<div class="preamble">
  <h1>You're nearly there</h1>
  <p class="subtitle">
    Please add your payment method for any co-pays that may be charged by your insurance.
  </p>
</div>

<iris-card>
  <div>
    <div class="payment-wrapper">
      <h3 data-test="ebcg-payment-method-header-text">
        Payment method
      </h3>
      <p>
        For your sessions with {{ providerName() }}, your claims will be handled by 
        Evernorth Behavioral Care Group, SonderMind's trusted partner for Cigna insurance.
      </p>
    </div>

    <div class="payment-wrapper">
      <form [formGroup]="ebcgAgreementForm">
        <iris-checkbox 
          formControlName="acceptedEbcgTerms" 
          data-test="ebcg-agreement-checkbox"
        >
          I agree to the 
          <a 
            class="iris-link-responsive" 
            [href]="ebcgTermsOfService" 
            target="_blank"
            rel="noopener noreferrer"
          >Terms of Service</a>
          and 
          <a 
            class="iris-link-responsive" 
            [href]="ebcgPrivacyPolicy" 
            target="_blank"
            rel="noopener noreferrer"
          >Privacy Policy</a>
          from Evernorth Behavioral Care Group
        </iris-checkbox>
      </form>
    </div>

    @if (!fromDirectBooking()) {
      <div class="external-link-button-container">
        <ng-container *ngTemplateOutlet="actionButton"></ng-container>
      </div>
    }
  </div>
</iris-card>
